import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import ScreenLoader from '../components/atoms/ScreenLoader';
import localStorageConstants, { addToLocalStorage } from '../constants/localstorage';
import { useAppDispatch } from '../hooks/reduxHooks';
import { doLogin } from '../redux/admin/adminSlice';
import AuthService from '../API/AuthService';

const AuthScreen = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const SSOtoken = location.state ? location.state.SSOtoken || null : null;

  useEffect(() => {
    // si llego con token lo autentico y si no
    // probablemente ya este logueado
    if (SSOtoken) {
      AuthService.authSSO({ dispatch, ssoToken: SSOtoken })
        .then(authRes => {
          doLogin(dispatch, {
            isLogged: true,
            loginData: {
              user: authRes,
            },
          });
          addToLocalStorage(localStorageConstants.token, authRes.token);
          history.push('/bandeja/colaborador');
        })
        .catch(() => {
          window.open(process.env.REACT_APP_ssoUrl, '_self');
        });
    } else {
      history.push('/home/colaborador');
    }
  }, []);

  return <ScreenLoader loading />;
};

export default AuthScreen;
